import React from 'react';
import { useFormState } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { nsform } from "../../i18n/namespaces";
import clsx from 'clsx';
import '@isyc-react/design/main';
export const RhfFormError = props => {
  const {
    control,
    message,
    className
  } = props;
  const {
    errors
  } = useFormState({
    control
  });
  const {
    t
  } = useTranslation(nsform.common);
  return /*#__PURE__*/React.createElement(React.Fragment, null, errors && Object.keys(errors).length > 0 && /*#__PURE__*/React.createElement("div", {
    className: clsx(className)
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-danger fw-bold"
  }, /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-alert-circle-outline me-2 text-danger"
  }), /*#__PURE__*/React.createElement("span", null, message !== null && message !== void 0 ? message : t('rhf.form.error.message')))));
};